import { render, staticRenderFns } from "./levelContentInput.vue?vue&type=template&id=77f27b06&scoped=true&"
import script from "./levelContentInput.vue?vue&type=script&lang=js&"
export * from "./levelContentInput.vue?vue&type=script&lang=js&"
import style0 from "./levelContentInput.vue?vue&type=style&index=0&id=77f27b06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f27b06",
  null
  
)

export default component.exports